<div class="app-layout">
  <app-header *ngIf="showHeaderFooter"></app-header>
  <main class="main-content" [class.full-screen]="!showHeaderFooter">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="showHeaderFooter"></app-footer>
  <!-- Toast notifications are handled by ToastService -->
  <!-- Floating components - hidden on admin pages -->
  <app-floating-appointment *ngIf="showFloatingComponents"></app-floating-appointment>
  <app-floating-call *ngIf="showFloatingComponents"></app-floating-call>
  <app-floating-whatsapp *ngIf="showFloatingComponents"></app-floating-whatsapp>
  <app-scroll-to-top *ngIf="showFloatingComponents"></app-scroll-to-top>
  <!-- Video component for home and product pages -->
  <app-floating-video></app-floating-video>
  <!-- Product card component for product pages (temporarily disabled) -->
  <!-- <app-floating-product-card></app-floating-product-card> -->
  
  <!-- Global Appointment Modal -->
  <app-appointment-modal 
    [isOpen]="isAppointmentModalOpen" 
    (closeModal)="closeAppointmentModal()">
  </app-appointment-modal>
</div>
